export default __webpack_public_path__ + "static/media/4-1.283dba76.jpg";